import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectNetNdpOptions = createSelector(
  [selectQbrState],
  (state) => state.documentSettings.netNdpOptions
)
